// @ts-nocheck
import { get, post, put, deleteRequest } from './utils/api/base';
const API_URL = process.env.REACT_APP_BASE_API_URL || 'http://localhost:3500';
/**
 * @typedef {Object} FrotaDisponibilidade
 * @property {number} Id - ID Ãºnico do registro
 * @property {string} DataDisponibilidade - Data de disponibilidade
 * @property {string} LocalCidade - Cidade do local
 * @property {string} LocalEstado - Estado do local
 * @property {string} Frota - NÃºmero da frota
 * @property {string} Veiculo - Placa do veÃ­culo
 * @property {string} TipoModelo - Tipo/modelo do veÃ­culo
 * @property {string} NomeMotorista - Nome do motorista
 * @property {string} NomeGestor - Nome do gestor
 * @property {boolean} Vazio - Status vazio
 * @property {boolean} Coleta - Status de coleta
 * @property {boolean} Negociacao - Status de negociaÃ§Ã£o
 * @property {boolean} DescargaPendente - Status de descarga pendente
 * @property {string} NomeComercial - Nome comercial
 * @property {string} Destino - Destino
 * @property {number} DiasParado - Dias parado
 * @property {string} DataModificacao - Data de modificaÃ§Ã£o
 * @property {string} UsuarioModificacao - UsuÃ¡rio que modificou
 * @property {string} UsuarioCriacao - UsuÃ¡rio que criou
 */
/**
 * @typedef {Object} FrotaDisponibilidadeCreatePayload
 * @property {string} DataDisponibilidade - Data de disponibilidade
 * @property {string} LocalCidade - Cidade do local
 * @property {string} LocalEstado - Estado do local
 * @property {string} Frota - NÃºmero da frota
 * @property {string} Veiculo - Placa do veÃ­culo
 * @property {string} TipoModelo - Tipo/modelo do veÃ­culo
 * @property {string} NomeMotorista - Nome do motorista
 * @property {string} NomeGestor - Nome do gestor
 * @property {boolean} Vazio - Status vazio
 * @property {boolean} Coleta - Status de coleta
 * @property {boolean} Negociacao - Status de negociaÃ§Ã£o
 * @property {boolean} DescargaPendente - Status de descarga pendente
 * @property {string} NomeComercial - Nome comercial
 * @property {string} Destino - Destino
 */
/**
 * @typedef {Object} FrotaDisponibilidadeFilters
 * @property {string} [LocalCidade] - Filtro por cidade
 * @property {string} [LocalEstado] - Filtro por estado
 * @property {string} [Frota] - Filtro por nÃºmero da frota
 * @property {string} [Veiculo] - Filtro por placa do veÃ­culo
 * @property {string} [TipoModelo] - Filtro por tipo/modelo
 * @property {string} [NomeMotorista] - Filtro por nome do motorista
 * @property {string} [NomeGestor] - Filtro por nome do gestor
 * @property {string} [NomeComercial] - Filtro por nome comercial
 * @property {string} [Destino] - Filtro por destino
 * @property {boolean} [Vazio] - Filtro por disponibilidade vazia
 * @property {boolean} [Coleta] - Filtro por coleta
 * @property {boolean} [Negociacao] - Filtro por negociaÃ§Ã£o
 * @property {boolean} [DescargaPendente] - Filtro por descarga pendente
 * @property {number} [quantidadePorPagina] - Quantidade de registros por pÃ¡gina
 * @property {number} [pagina] - NÃºmero da pÃ¡gina
 */
/**
 * @typedef {Object} FrotasDisponibilidadeResponse
 * @property {FrotaDisponibilidade[]} registros - Lista de registros de disponibilidade
 * @property {number} totalRegistros - Total de registros encontrados
 * @property {number} paginaAtual - PÃ¡gina atual
 * @property {number} quantidadePorPagina - Quantidade de registros por pÃ¡gina
 */
/**
 * @typedef {Object} FrotaUltimaPosicaoPayload
 * @property {string} placa - Placa do veiculo que sera consultada
 */
/**
 * @typedef {Object} FrotaUltimaPosicaoResponse
 * @property {boolean} success - Indica se a integracao retornou dados
 * @property {string} placa - Placa consultada (normalizada)
 * @property {Object} posicao - Dados principais retornados pelo SOAP
 * @property {Object} [integracao] - Informacoes auxiliares da resposta externa
 */
/**
 * @typedef {Object} ModelosVeicularesFilters
 * @property {number} [page]                       Número da página (default no backend)
 * @property {number} [limit]                      Quantidade por página (default no backend)
 * @property {string} [search]                     Busca por descrição ou código
 * @property {string} [situacao]                   Situação
 * @property {string} [codigoTipoModeloVeicular]   Código do Tipo de Modelo Veicular
 * @property {string} [unidadeCapacidade]          Unidade de Capacidade
 * @property {string} [codigoTipoCargaANTT]        Código do Tipo de Carga ANTT
 * @property {string} [codigoIntegracao]           Código de Integração
 * @property {string} [nomeTipoModeloVeicular]     Nome do Tipo de Modelo Veicular
 * @property {number|string} [ocupacaoCubicaPallets]
 * @property {number|string} [ocupacaoCubicaMaxima]
 * @property {number|string} [quantidadePallet]
 * @property {number|string} [capacidadeMaximoPallets]
 * @property {number|string} [toleranciaMinimaPallets]
 * @property {number|string} [toleranciaMinimaCarregamento]
 * @property {number|string} [numeroEixos]
 * @property {number|string} [capacidadeModelo]
 * @property {number|string} [quantidadeExtraExcedenteTolerado]
 * @property {number|string} [toleranciaExtra]
 */
/**
 * @typedef {Object} ModeloVeicular
 * @property {number} id
 * @property {string} [situacao]
 * @property {number} [ocupacaoCubicaPallets]
 * @property {number} [toleranciaMinimaPallets]
 * @property {number} [toleranciaMinimaCarregamento]
 * @property {string} [unidadeCapacidade]
 * @property {string} [codigoTipoCargaANTT]
 * @property {string} [codigoIntegracao]
 * @property {string} [codigoTipoModeloVeicular]
 * @property {number} [numeroEixos]
 * @property {number} [capacidadeModelo]
 * @property {number} [ocupacaoCubicaPallets]
 * @property {number} [ocupacaoCubicaMaxima]
 * @property {number} [quantidadePallet]
 * @property {number} [capacidadeMaximoPallets]
 * @property {string} [codigoInterno]
 * @property {string} [descricao]
 * @property {number} [quantidadeExtraExcedenteTolerado]
 * @property {string} [nomeTipoModeloVeicular]
 * @property {number} [toleranciaExtra]
 */
/**
 * @typedef {Object} ModelosVeicularesResponse
 * @property {ModeloVeicular[]} registros
 * @property {number} totalRegistros
 * @property {number} paginaAtual
 * @property {number} quantidadePorPagina
 */
/**
 * Busca registros de disponibilidade com filtros
 * @param {FrotaDisponibilidadeFilters} filters - Filtros para a busca
 * @returns {Promise<FrotasDisponibilidadeResponse>} Resposta com lista de disponibilidade
 */
export const getFrotasDisponibilidade = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    // Adicionar filtros apenas se tiverem valor
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${API_URL}/frotas/disponibilidade?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca um registro de disponibilidade especÃ­fico por ID
 * @param {number} id - ID do registro
 * @returns {Promise<FrotaDisponibilidade>} Dados da disponibilidade
 */
export const getFrotaDisponibilidadeById = async (id) => {
    const response = await get(`${API_URL}/frotas/disponibilidade/${id}`);
    return response?.data || response;
};
/**
 * Cria um novo registro de disponibilidade
 * @param {FrotaDisponibilidadeCreatePayload} payload - Dados da disponibilidade
 * @returns {Promise<FrotaDisponibilidade>} Registro criado
 */
export const createFrotaDisponibilidade = async (payload) => {
    const response = await post(`${API_URL}/frotas/disponibilidade/criar`, payload);
    return response?.data || response;
};
/**
 * Atualiza um registro de disponibilidade existente
 * @param {number} id - ID do registro
 * @param {FrotaDisponibilidadeCreatePayload} payload - Dados atualizados
 * @returns {Promise<FrotaDisponibilidade>} Registro atualizado
 */
export const updateFrotaDisponibilidade = async (id, payload) => {
    const response = await put(`${API_URL}/frotas/disponibilidade/${id}`, payload);
    return response?.data || response;
};
/**
 * Exclui um registro de disponibilidade
 * @param {number} id - ID do registro a ser excluÃ­do
 * @returns {Promise<void>}
 */
export const deleteFrotaDisponibilidade = async (id) => {
    await deleteRequest(`${API_URL}/frotas/disponibilidade/${id}`);
};
/**
 * Consulta posições salvas para uma lista de placas
 * @param {string[]} placas - Lista de placas
 * @returns {Promise<any>} Resposta da API com os itens por placa
 */
export const getPosicoesSalvasPorPlacas = async (placas = [], config = {}) => {
    const sanitizedPlacas = (Array.isArray(placas) ? placas : [])
        .map(placa => String(placa || '').trim().toUpperCase())
        .filter(Boolean);
    const response = await post(`${API_URL}/veiculos/posicoes-salvas/placas`, sanitizedPlacas, config);
    return response?.data || response || {};
};
/**
 * Consulta a ultima posicao geral do veiculo no provedor externo
 * @param {FrotaUltimaPosicaoPayload & { idVeiculo?: number|string, frota?: string }} payloadOrData
 * @returns {Promise<FrotaUltimaPosicaoResponse>}
 */
export const getUltimaPosicaoGeral = async (payloadOrData, config = {}) => {
    const payload = typeof payloadOrData === 'string' ? { placa: payloadOrData } : payloadOrData || {};
    const rawIdVeiculo = payload?.idVeiculo ?? payload?.IdVeiculo ?? payload?.codigo ?? payload?.id ?? null;
    const rawPlaca = payload?.placa ?? payload?.veiculo ?? '';
    const rawFrota = payload?.frota ?? payload?.numeroFrota ?? payload?.Frota ?? '';
    const placa = String(rawPlaca || '').trim().toUpperCase();
    const frota = String(rawFrota || '').trim();
    const idVeiculo = rawIdVeiculo === null || rawIdVeiculo === undefined || rawIdVeiculo === ''
        ? null
        : rawIdVeiculo;
    if (!idVeiculo && !placa && !frota) {
        return {
            placa: '',
            frota: '',
            integracao: null,
            posicao: null
        };
    }
    const requestPayload = {
        ...(idVeiculo ? { idVeiculo } : {}),
        ...(placa ? { placa } : {}),
        ...(frota ? { frota } : {})
    };
    const response = await post(`${API_URL}/veiculos/ultima-posicao/geral`, requestPayload, config);
    return response?.data || response || {
        placa,
        frota,
        integracao: null,
        posicao: null
    };
};
/**
 * Consulta o provedor externo para obter a ultima posicao por placa
 * @param {FrotaUltimaPosicaoPayload | string} payloadOrPlaca - Objeto com placa ou a placa diretamente
 * @returns {Promise<FrotaUltimaPosicaoResponse>}
 */
export const getUltimaPosicaoPorPlaca = async (payloadOrPlaca, config = {}) => {
    const payload = typeof payloadOrPlaca === 'string' ? { placa: payloadOrPlaca } : payloadOrPlaca || {};
    const placa = String(payload?.placa || payload?.veiculo || '').trim().toUpperCase();
    if (!placa) {
        return {
            placa: '',
            integracao: null,
            posicao: null
        };
    }
    const response = await getPosicoesSalvasPorPlacas([placa], config);
    const item = (response?.itens || []).find(entry => String(entry?.placa || '').trim().toUpperCase() === placa);
    if (!item || item?.encontrada === false) {
        return {
            placa,
            integracao: null,
            posicao: null
        };
    }
    return {
        placa: item?.placa || placa,
        frota: item?.frota || '',
        integracao: item?.ultimaTecnologiaPosicao || null,
        posicao: {
            latitude: item?.latitude ?? null,
            longitude: item?.longitude ?? null,
            dataPosicao: item?.dataAtualizacao ?? null,
            cidade: '',
            estado: '',
            logradouro: '',
            idVeiculo: item?.idVeiculo ?? null
        }
    };
};
/**
 * Busca disponibilidade por frota
 * @param {string} frota - NÃºmero da frota
 * @returns {Promise<FrotaDisponibilidade[]>} Lista de disponibilidade da frota
 */
export const getDisponibilidadeByFrota = async (frota) => {
    const response = await get(`${API_URL}/frotas/disponibilidade/frota/${frota}`);
    return response?.data || response || [];
};
/**
 * Busca disponibilidade por veÃ­culo
 * @param {string} veiculo - Placa do veÃ­culo
 * @returns {Promise<FrotaDisponibilidade[]>} Lista de disponibilidade do veÃ­culo
 */
export const getDisponibilidadeByVeiculo = async (veiculo) => {
    const response = await get(`${API_URL}/frotas/disponibilidade/veiculo/${veiculo}`);
    return response?.data || response || [];
};
/**
 * Busca disponibilidade por motorista
 * @param {string} motorista - Nome do motorista
 * @returns {Promise<FrotaDisponibilidade[]>} Lista de disponibilidade do motorista
 */
export const getDisponibilidadeByMotorista = async (motorista) => {
    const response = await get(`${API_URL}/frotas/disponibilidade/motorista/${encodeURIComponent(motorista)}`);
    return response?.data || response || [];
};
/**
 * Busca disponibilidade por local
 * @param {string} cidade - Cidade
 * @param {string} estado - Estado
 * @returns {Promise<FrotaDisponibilidade[]>} Lista de disponibilidade do local
 */
export const getDisponibilidadeByLocal = async (cidade, estado) => {
    const response = await get(`${API_URL}/frotas/disponibilidade/local?cidade=${encodeURIComponent(cidade)}&estado=${encodeURIComponent(estado)}`);
    return response?.data || response || [];
};
/**
 * ObtÃ©m estatÃ­sticas de disponibilidade
 * @returns {Promise<Object>} EstatÃ­sticas de disponibilidade
 */
export const getEstatisticasDisponibilidade = async () => {
    const response = await get(`${API_URL}/frotas/disponibilidade/estatisticas`);
    return response?.data || response || {};
};
/**
 * Lista modelos veiculares com filtros (GET /modelos-veiculares)
 * @param {ModelosVeicularesFilters} [filters={}]
 * @returns {Promise<ModelosVeicularesResponse>}
 */
export const getModelos = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = queryParams.toString().length > 0
        ? `${API_URL}/modelos-veiculares?${queryParams.toString()}`
        : `${API_URL}/modelos-veiculares`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca um modelo veicular por ID (GET /modelos-veiculares/{id})
 * @param {number|string} id
 * @returns {Promise<{ modelo: ModeloVeicular }>}
 */
export const getModeloById = async (id) => {
    const url = `${API_URL}/modelos-veiculares/${id}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Cria um modelo veicular (POST /modelos-veiculares)
 * @param {Partial<ModeloVeicular>} payload
 * @returns {Promise<any>}
 */
export const createModelo = async (payload) => {
    const url = `${API_URL}/modelos-veiculares`;
    const response = await post(url, payload);
    return response?.data || response || {};
};
/**
 * Atualiza um modelo veicular (PUT /modelos-veiculares/{id})
 * @param {number|string} id
 * @param {Partial<ModeloVeicular>} payload
 * @returns {Promise<any>}
 */
export const updateModelo = async (id, payload) => {
    const url = `${API_URL}/modelos-veiculares/${id}`;
    const response = await put(url, payload);
    return response?.data || response || {};
};
/**
 * Remove um modelo veicular (DELETE /modelos-veiculares/{id})
 * @param {number|string} id
 * @returns {Promise<any>}
 */
export const deleteModelo = async (id) => {
    const url = `${API_URL}/modelos-veiculares/${id}`;
    const response = await deleteRequest(url);
    return response?.data || response || {};
};
/**
 * Lista veiculos com filtros (GET /veiculos)
 * @param {VeiculosFilters} [filters={}]
 * @returns {Promise<VeiculosResponse>}
 */
export const getVeiculos = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = queryParams.toString().length > 0
        ? `${API_URL}/veiculos?${queryParams.toString()}`
        : `${API_URL}/veiculos`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca um veiculo por ID (GET /veiculos/{id})
 * @param {number|string} id
 * @returns {Promise<{ veiculo: Veiculo }>}
 */
export const getVeiculoById = async (id) => {
    const url = `${API_URL}/veiculos/${id}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Cria um veiculo (POST /veiculos)
 * @param {Partial<Veiculo>} payload
 * @returns {Promise<any>}
 */
export const createVeiculo = async (payload) => {
    const url = `${API_URL}/veiculos`;
    const response = await post(url, payload);
    return response?.data || response || {};
};
/**
 * Atualiza um veiculo (PUT /veiculos/{id})
 * @param {number|string} id
 * @param {Partial<Veiculo>} payload
 * @returns {Promise<any>}
 */
export const updateVeiculo = async (id, payload) => {
    const url = `${API_URL}/veiculos/${id}`;
    const response = await put(url, payload);
    return response?.data || response || {};
};
/**
 * Relaciona um veiculo a um pedido (POST /veiculos/{id}/relacionar-pedido)
 * @param {number|string} idVeiculo
 * @param {number|string} idPedido
 * @returns {Promise<any>}
 */
export const relacionarVeiculoPedido = async (idVeiculo, idPedido, desvincular = false) => {
    const url = `${API_URL}/veiculos/${idVeiculo}/relacionar-pedido`;
    const payload = {
        IdPedido: idPedido,
        desvincular: Boolean(desvincular)
    };
    const response = await post(url, payload);
    return response?.data || response || {};
};
/**
 * Remove um veiculo (DELETE /veiculos/{id})
 * @param {number|string} id
 * @returns {Promise<any>}
 */
export const deleteVeiculo = async (id) => {
    const url = `${API_URL}/veiculos/${id}`;
    const response = await deleteRequest(url);
    return response?.data || response || {};
};
